"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tvertical-align: middle;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: none;\n\n\t&:checked + ", ":after {\n\t\ttransform: scale(1);\n\t\tvisibility: visible;\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tborder: none;\n\tborder: ", " solid ", ";\n\tmargin: ", ";\n\theight: 22px;\n\twidth: 22px;\n\tborder-radius: 50%;\n\ttransition: all 0.2s ease-in;\n\tpadding: 0px;\n\tvertical-align: middle;\n\n\t&:after {\n\t\tcontent: '';\n\t\tdisplay: block;\n\t\tborder-radius: 50%;\n\t\tbackground-color: ", ";\n\t\tvisibility: hidden;\n\t\ttransform: scale(0);\n\t\ttransition: transform 0.2s ease-in-out;\n\t\theight: 12px;\n\t\twidth: 12px;\n\t\tposition: absolute;\n\t\ttop: 3px;\n\t\tleft: 3px;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tvertical-align: middle;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Wrapper = _styledComponents.default.div(_templateObject());

Wrapper.displayName = 'Wrapper';

var Box = _styledComponents.default.label(_templateObject2(), _vars.default.borderWidth, _colors.default.borderColor, _spacing.default.s1, _colors.default.secondary);

Box.displayName = 'Box';

var Input = _styledComponents.default.input(_templateObject3(), Box);

Input.displayName = 'Input';

var Label = _styledComponents.default.label(_templateObject4());

Label.displayName = 'Label';

var Radio = function Radio(_ref) {
  var name = _ref.name,
      id = _ref.id,
      className = _ref.className,
      label = _ref.label,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "id", "className", "label"]);

  return _react.default.createElement(Wrapper, {
    className: className
  }, _react.default.createElement(Input, _extends({
    type: "radio",
    name: name,
    id: id
  }, props)), _react.default.createElement(Box, {
    htmlFor: id
  }), label && _react.default.createElement(Label, {
    htmlFor: id
  }, label));
};

Radio.displayName = 'Radio';
Radio.defaultProps = {
  name: undefined,
  id: undefined,
  className: undefined,
  label: undefined
};
Radio.propTypes = {
  name: _propTypes.string,
  id: _propTypes.string,
  label: _propTypes.string,
  className: _propTypes.string
};
var _default = Radio;
exports.default = _default;